import 'regenerator-runtime/runtime';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import {
  getSelectListItemAccounts,
  getSelectListItemTrade,
  getSelectListItemToRepair,
  getSelectListRegion,
  getSelectListMarket,
  getSelectListMarketByRegionId,
  getSelectListPhasesByProjectId,
  getSelectListModelsByProjectId,
  getSelectListSubcontractor,
  getSelectListRooms,
  getSelectListProjects,
  getSelectListRequestTypes,
  getSelectListWorkOrderTypes,
  getSelectListItemProblemByItemRepairId,
  getSelectListItemToRepairByTradeId,
  getSelectListLots,
  getSelectListInsurances,
  setupCommonAWS,
  uploadCommonToS3,
  uploadSignatureToS3,
  uploadMultiSignatureToS3
} from './api';
import * as SelectActionType from './constants';
import * as NotifyActionType from '../constants/notification-action-type';

export function* getSelectListItemAccountsAsync(action) {

  const result = yield call(getSelectListItemAccounts, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListItemTradeAsync(action) {

  const result = yield call(getSelectListItemTrade, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListItemToRepairAsync(action) {

  const result = yield call(getSelectListItemToRepair, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListItemToRepairByTradeIdAsync(action) {

  const result = yield call(getSelectListItemToRepairByTradeId, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListItemProblemByItemRepairIdAsync(action) {

  const result = yield call(getSelectListItemProblemByItemRepairId, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListRegionAsync(action) {

  const result = yield call(getSelectListRegion, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListMarketAsync(action) {

  const result = yield call(getSelectListMarket, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListMarketByRegionIdAsync(action) {

  const result = yield call(getSelectListMarketByRegionId, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListPhaseByProjectIdAsync(action) {

  const result = yield call(getSelectListPhasesByProjectId, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListModelByProjectIdAsync(action) {

  const result = yield call(getSelectListModelsByProjectId, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListSubcontractordAsync(action) {

  const result = yield call(getSelectListSubcontractor, action.params.param);
  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListRoomAsync(action) {

  const result = yield call(getSelectListRooms, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListProjectsAsync(action) {

  const result = yield call(getSelectListProjects, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListRequestTypesAsync(action) {

  const result = yield call(getSelectListRequestTypes, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListWorkOrderTypesAsync(action) {

  const result = yield call(getSelectListWorkOrderTypes, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListLotsAsync(action) {

  const result = yield call(getSelectListLots, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListInsurancesAsync(action) {

  const result = yield call(getSelectListInsurances, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* setupCommonAWSAsync(action) {
  const result = yield call(setupCommonAWS, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback(result.data, true);
    }
  }
  else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });

    if (action.callback) {
      action.callback(result.data, false);
    }
  }
}

export function* uploadCommonToS3Async(action) {
  yield call(uploadCommonToS3, action.paramsUpload, action.callback);
}

export function* uploadSignatureToS3Async(action) {
  yield call(uploadSignatureToS3, action.paramsUpload, action.callback);
}

export function* uploadMultiSignatureToS3Async(action) {
  yield call(uploadMultiSignatureToS3, action.params, action.callback);
}

export default function* WatchCommon() {
  yield all([
    takeLatest(SelectActionType.COMMON_SELECT_LIST_ACCOUNT_ASYNC, getSelectListItemAccountsAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_ITEM_TRADE_ASYNC, getSelectListItemTradeAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_ITEM_TO_REPAIR_ASYNC, getSelectListItemToRepairAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_REGION_ASYNC, getSelectListRegionAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_MARKET_ASYNC, getSelectListMarketAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_MARKET_BY_REGION_ID_ASYNC, getSelectListMarketByRegionIdAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_PHASE_BY_PROJECT_ID_ASYNC, getSelectListPhaseByProjectIdAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_MODEL_BY_PROJECT_ID_ASYNC, getSelectListModelByProjectIdAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_SUBCONTRACTOR_ASYNC, getSelectListSubcontractordAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_ROOM_ASYNC, getSelectListRoomAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_PROJECT_ASYNC, getSelectListProjectsAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_REQUEST_TYPES_ASYNC, getSelectListRequestTypesAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_WORK_ORDER_TYPES_ASYNC, getSelectListWorkOrderTypesAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_ITEM_TO_REPAIR_BY_TRADE_ID_ASYNC, getSelectListItemToRepairByTradeIdAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_PROBLEM_BY_ITEM_REPAIR_ID_ASYNC, getSelectListItemProblemByItemRepairIdAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_LOT_ASYNC, getSelectListLotsAsync),
    takeLatest(SelectActionType.COMMON_SELECT_LIST_INSURANCE_ASYNC, getSelectListInsurancesAsync),
    takeLatest(SelectActionType.COMMON_SETUP_AWS_ASYNC, setupCommonAWSAsync),
    takeLatest(SelectActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC, uploadCommonToS3Async),
    takeLatest(SelectActionType.COMMON_UPLOAD_FILE_TO_S3_HOME_INVENTORY_ASYNC, uploadCommonToS3Async),
    takeLatest(SelectActionType.COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC,uploadSignatureToS3Async),
    takeLatest(SelectActionType.COMMON_UPLOAD_MULTI_SIGNATURE_TO_S3_ASYNC,uploadMultiSignatureToS3Async)
  ]);
}

const processAfterSuccess = (action, result) => {
  var actionTypes = [];

  action.params.nextAction.forEach(item => {
    if (item.params === null && typeof (item.action) !== 'undefined') {
      actionTypes.push(put({ type: item.action, data: result.data, internalParams: item['internalParams'] }));
    }

    if (item.params !== null && typeof (item.action) !== 'undefined') {
      actionTypes.push(put({ type: item.action, params: item.params }));
    }

    if (item.callBack) {
      item.callBack(result.data);
    }
  });
  // $.each(action.params.nextAction, function (i, item) {
  //     if (item.params === null && typeof (item.action) !== "undefined") {
  //         actionTypes.push(put({ type: item.action, data: result.data, internalParams: item["internalParams"] }));
  //     }

  //     if (item.params !== null && typeof (item.action) !== "undefined") {
  //         actionTypes.push(put({ type: item.action, params: item.params }));
  //     }

  //     if (item.callBack) {
  //         item.callBack(result.data);
  //     }
  // });

  return actionTypes;
};



// WEBPACK FOOTER //
// ./src/Common/saga.js